import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { BiltyCompanyDetailsCss as useStyles } from '../BiltyCss';
import AddCompanyDetailsDialog from '../../../components/JourneyBiltyDialogs/AddCompanyDetailsDialog';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import {
    IconButton,
    Switch
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import S3Uploader from '../../../components/s3Uploader/s3Uploader';
import { loadElr, getTripDetailsV3 } from '../../../../store/actions/tripActionCreator';
import * as logger from '../../../../logger';
import Alert from '@material-ui/lab/Alert';
import { isFunction } from '../../../../utils/utils';
const BiltyCompanyDetails = ({ trip, user,selectedTrip,selectedLr,journey,updateJourney, dispatchLoadElr, watermarkValue, open, dispatchTripDetailsAction }) => {

    const classes = useStyles();

    const elrDataDetails = trip && trip.elrLoadData && trip.elrLoadData.company_details ? trip.elrLoadData.company_details : ""

    const [companyDetailsDialog, setCompanyDetailsDialog] = useState(false);
    const [watermarkToggle, setWatermarkToggle] = useState(false);
    const [companyPhoto, setCompanyPhoto] = useState({ s3Link: "" });
    const [elrData, setElrData] = useState({ logo_link: "" });
    const [editDetails, setEditDetails] = useState(false);
    const [checkFileType, setCheckFileType] = useState(false);
    const [sizeFlag, setSizeFlag] = useState(false);

    const elrId = selectedLr && selectedLr.id ? selectedLr.id : "";
    const tripId = selectedTrip && selectedTrip.id ? selectedTrip.id : "";

    useEffect(() => {

        if (trip && trip.elrInfo) {
            setWatermarkToggle(trip.elrInfo.use_watermark)
        }

    }, [trip.elrInfo]);

    useEffect(() => {

        if (elrDataDetails.name || elrDataDetails.contact_number) {
            setCompanyDetailsDialog(false);
        } else {
            setCompanyDetailsDialog(true);
        }

    }, []);

    useEffect(() => {

        if (trip && trip.elrLoadData && trip.elrLoadData.company_details) {
            setElrData(trip.elrLoadData.company_details)
        }

    }, [trip.elrLoadData]);

    useEffect(() => {

        if (isFunction(updateJourney) && journey.id) {
            updateJourney(journey.id)
        }

    }, [open]);

    const handleCompanyDetailsDialogClose = () => {
        setCompanyDetailsDialog(false);
        setEditDetails(false);
    }

    const handleChange = (e) => {
        setWatermarkToggle(!watermarkToggle);
        watermarkValue(!watermarkToggle);
    }

    const handleEditCompantDetails = () => {
        setCompanyDetailsDialog(true);
        setEditDetails(true);
    }

    const handleAddPhoto = (file) => {

        setCheckFileType(false);
        setSizeFlag(false);

        const newPhoto = {
            s3Link: file
        }

        elrData.logo_link = file;

        setCompanyPhoto(newPhoto);
    }

    const handleAddCompanyDetailsConfirm = () => {
        setCompanyDetailsDialog(false);
        setEditDetails(false);
        dispatchLoadElr(
            tripId,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log('BiltyCompanyDetails Dweb', "Load Elr Successfull");
                }
            },
            () => {
                logger.log('BiltyCompanyDetails Dweb', "Load Elr Failed");
            }
        )
    }

    const handleInvalidUpload = (values) => {
        if (values.checkFileType) {
            setCheckFileType(true);
        }
        if (values.sizeFlag) {
            setSizeFlag(true);
        }
    }

    return (
        <>
            <div className={classes.divContainer}>
                <div className={classes.divV3}>
                    {elrData && !elrData.logo_link &&
                        <div className={classes.divPhoto}>
                            <div className={classes.divV5}>
                                <PhotoCameraIcon className={classes.cameraIcon} />
                                <div className={classes.divV1}>Logo</div>
                            </div>
                        </div>
                    }
                    {elrData && elrData.logo_link &&
                        <div>
                            <img src={elrData.logo_link} className={classes.imgV1} />
                            <S3Uploader toggle={true} directoryName={"dweb-images/Bilty/BiltyCompanyDetails"} handleFile={handleAddPhoto} fromBiltyCompanyDetails={true} id="biltyCompanyDetails" displayErrorBelow={handleInvalidUpload} displayErrorMessageBelow={true} />
                        </div>
                    }
                </div>

                <div>
                    {checkFileType &&
                        <Alert severity="error" className="mtV1">Please select only .jpg, .jpeg and .png files</Alert>
                    }
                    {sizeFlag &&
                        <Alert severity="error" className="mtV1">File size must be below 5MB.</Alert>
                    }
                </div>

                <div className={classes.divWatermark}>
                    <div className={classes.fwBold}>
                        Use Logo as Watermark
                    </div>
                    <Switch
                        checked={watermarkToggle}
                        onChange={handleChange}
                        name="watermark"
                        className={classes.switch}
                        classes={{ track: classes.switchTrack, thumb: classes.switchThumb, checked: classes.switchChecked }}
                    />
                </div>

                <div className={classes.divV2}>
                    <div className={classes.divV4}>
                        <div>
                            <div className={classes.divTitle}>Company Name</div>
                            <div className={classes.fwBold}>{elrData && elrData.name ? elrData.name : ""}</div>
                        </div>
                        <div>
                            <IconButton className={classes.editButton} onClick={() => handleEditCompantDetails()}>
                                <EditIcon className={classes.editIcon} />
                            </IconButton>
                        </div>
                    </div>

                    <div className={classes.mtV1}>
                        <div className={classes.divTitle}>GST Number</div>
                        <div className={classes.divGst}>{elrData && elrData.gst_number ? elrData.gst_number : "--"}</div>
                    </div>

                    <div className={classes.mtV1}>
                        <div className={classes.divTitle}>Company Address Line 1</div>
                        <div className={classes.fwBold}>{elrData && elrData.address_line_1 ? elrData.address_line_1 : "--"}</div>
                    </div>

                    <div className={classes.mtV1}>
                        <div className={classes.divTitle}>Company Address Line 2</div>
                        <div className={classes.fwBold}>{elrData && elrData.address_line_2 ? elrData.address_line_2 : "--"}</div>
                    </div>

                    <div className={classes.divRow}>
                        <div>
                            <div className={classes.divTitle}>State</div>
                            <div className={classes.fwBold}>{elrData && elrData.state ? elrData.state : "--"}</div>
                        </div>
                        <div className={classes.divEnd}>
                            <div className={classes.divTitle}>Pincode</div>
                            <div className={classes.fwBold}>{elrData && elrData.pincode ? elrData.pincode : "--"}</div>
                        </div>
                    </div>

                    <div className={classes.mtV1}>
                        <div className={classes.divTitle}>Mobile Number</div>
                        <div className={classes.fwBold}>{elrData && elrData.contact_number ? elrData.contact_number.replace(/(\d{5})(\d{5})/, '$1-$2') : "--"}</div>
                    </div>

                    {elrData && elrData.email &&
                        <div className={classes.mtV1}>
                            <div className={classes.divTitle}>Email Id</div>
                            <div className={classes.fwBold}>{elrData && elrData.email ? elrData.email : ""}</div>
                        </div>
                    }
                </div>
            </div>
            {companyDetailsDialog && <AddCompanyDetailsDialog journey={journey} updateJourney={updateJourney} selectedTrip={selectedTrip} selectedLr={selectedLr} open={companyDetailsDialog} onClose={handleCompanyDetailsDialogClose} edit={editDetails} elrIdValue={elrId} elrDetailsData={elrData} onConfirm={handleAddCompanyDetailsConfirm} />}
        </>
    )

}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchLoadElr: (tripId, onSuccess, onFailure) => {
        dispatch(loadElr(tripId, onSuccess, onFailure))
    },
    dispatchTripDetailsAction: (tripId, onSuccess, onError) => {
        dispatch(getTripDetailsV3(tripId, onSuccess, onError))
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(BiltyCompanyDetails);